"use client";
import { useGlobalContent } from "@app/[locale]/GlobalContentProvider";
import { RichText } from "@components/cms/rich-text-renderer/RichText";
import { SubNavigation } from "@components/cms/sub-navigation/SubNavigation";
import type { IPageProductCategoryPage } from "@contentful-api/types/contentful";
import { CommonCMS } from "@lib/constants/contentful";
import { useMicrocopy } from "@lib/contentful/microcopy/MicrocopyContext";
import { ModulesRenderer } from "@lib/contentful/modules-renderer/ModulesRenderer";
import { PageHeading } from "@ecco/ui/page-heading";
import { Box } from "@ecco/ui/box";
import { MainWrapper } from "@components/ui/main-wrapper/mainWrapper";

type ProductCategoryPageProps = {
    page: IPageProductCategoryPage;
};

export const ProductCategoryPage = ({ page }: ProductCategoryPageProps) => {
    const { siteSettings } = useGlobalContent();
    const authorizationInvitation = siteSettings.auth.authorizationInvitation;

    const fields = page?.fields;
    const {
        title,
        desc,
        titleSize = "xlarge",
        descriptionSize = "normal",
        modules,
        subNavigationItems,
    } = fields ?? {};

    const { getMultiple } = useMicrocopy();

    const microcopies = getMultiple(CommonCMS.shared, [
        CommonCMS.generic.readMore,
        CommonCMS.generic.readLess,
    ]);

    return (
        <>
            <Box mt={[5, 8]}>
                <PageHeading
                    title={title}
                    description={<RichText data={desc} />}
                    showMoreLabel={microcopies[CommonCMS.generic.readMore]}
                    showLessLabel={microcopies[CommonCMS.generic.readLess]}
                    titleSize={titleSize}
                    descriptionSize={descriptionSize}
                />
            </Box>
            <MainWrapper>
                <SubNavigation linksCollection={subNavigationItems} />
                <ModulesRenderer
                    modules={modules}
                    authorizationInvitation={authorizationInvitation}
                />
            </MainWrapper>
        </>
    );
};
